angular
    .module('app')
    .component('segments', {
        templateUrl: '/templates/pages/segments/segments.html',
        controller: 'SegmentsController',
        controllerAs: 'vm',
    });